export const ART_TYPE_OPTIONS = [
  'Painting', 'Sculpture', 'Photography', 'Mixed Media', 'Digital', 'Installation', 'Drawing', 'Print'
];

export const VENUE_TYPE_OPTIONS = [
  { value: 'home', label: 'Home' },
  { value: 'cafe', label: 'Cafe' },
  { value: 'art_gallery', label: 'ArtGallery' },
  { value: 'library', label: 'Library' },
  { value: 'restaurant', label: 'Restaurant' },
  { value: 'retail_space', label: 'RetailSpace' },
  { value: 'other', label: 'Other' },
];

export const LIGHTING_ENVIRONMENT_OPTIONS = [
  'Track lighting', 'Natural light', 'Fluorescent lighting', 'Climate control', 'Humidity control'
];

export const ART_EVENT_OPTIONS = [
  'Art Festivals', 'Art Flea Markets', 'Street Art Market', 'Gallery Exhibitions'
];

export const FOOT_TRAFFIC_OPTIONS = [
  '0–10 per day', '10–50 per day', '50+ per week'
];

export const DISPLAY_AVAILABILITY_OPTIONS = [
  'Weekdays only', 'Evenings', 'Weekends', 'Full-time display'
];
